module.exports = __webpack_public_path__ + "img/hr-branch-particle-08.b7aaa6eb.png";